import { render, staticRenderFns } from "./UserProxiesList.vue?vue&type=template&id=80ad57ae&"
import script from "./UserProxiesList.vue?vue&type=script&lang=js&"
export * from "./UserProxiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports